import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { getSession } from '../../gateways/session'
import { logUser, logout } from '../../actions';

export function requireAuthentication(Component) {

  class AuthenticatedComponent extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        ready: false,
        target: null
      }
    }

    renderComponent() {
      if ( this.state.ready ) {
        return this.state.target;
      }
    }

    componentWillMount() {
      this.checkAuthenticated();
    }

    checkAuthenticated() {
      if ( this.props.user.isAuthenticated === true ) {
        this.setState({
          ready: true,
          target: (<Component {...this.props}/>)
        });
      } else {
        getSession().then((data) => {
          if ( data.error ) {
            this.props.logout();
            this.setState({
              ready: true,
              target: (<Redirect to="/login"/>)
            });
          } else {
            this.props.logUser({
              user: data.user,
              permissions: data.permissions
            });
            this.setState({
              ready: true,
              target: (<Component {...this.props}/>)
            });
          }
        });
      }
    }

    render () {
      return (
        <div>
          {this.renderComponent()}
        </div>
      )
    }
  }

  const mapStateToProps = (state) => ({
    user: state.user
  });

  return connect(mapStateToProps, {logout, logUser})(AuthenticatedComponent);
}

export function requireAuthorization(authorize = () => true, Component, redirect = '/') {

  class Authorization extends React.Component {
    render () {
      return authorize(this.props.state) ? <Component {...this.props}/> : <Redirect to={redirect}/>;
    }
  }

  const mapStateToProps = (state) => ({ state: state });

  return connect(mapStateToProps)(Authorization);
}

export function checkPermission(permissions = [], requiredPermission = '') {
  return permissions.indexOf(requiredPermission) >= 0;
}

export function checkBackend(state) {
  return checkPermission(state.user.permissions, 'backend');
}

export function checkDoSurveys(state) {
  return checkPermission(state.user.permissions, 'do_survey');
}

export function checkFrontend(state) {
  return checkPermission(state.user.permissions, 'frontend');
}



// WEBPACK FOOTER //
// ./src/components/Authorization/Authorization.js